module.exports = __webpack_public_path__ + "img/shutterstock_323846798.460d4d2e.png";